import { InvestmentFieldConfig, InvestmentFormConfig } from "./types";

// ─── Wspólne pola ───────────────────────────────────────────────────────────

const contractFileField: InvestmentFieldConfig = {
  name: "contractFile",
  label: "Umowa",
  type: "file",
  placeholder: "",
  required: false,
  multiple: 10,
};

const photoFilesField: InvestmentFieldConfig = {
  name: "photoFiles",
  label: "Zdjęcia",
  type: "file",
  placeholder: "",
  required: false,
  multiple: 10,
  accept: ".png,.jpg,.jpeg",
  showPreview: true,
};

const nameField: InvestmentFieldConfig = {
  name: "name",
  label: "Nazwa",
  type: "text",
  placeholder: "",
  required: true,
};

const currencyField: InvestmentFieldConfig = {
  name: "currencyUuid",
  label: "Waluta",
  type: "select",
  placeholder: "Wybierz",
  required: false,
};

const currencyFieldRequired: InvestmentFieldConfig = {
  ...currencyField,
  required: true,
};

const quantityCryptoField: InvestmentFieldConfig = {
  name: 'quantity',
  label: 'Ilość',
  type: 'number',
  placeholder: '',
  required: true,
  step: 'any',
  precision: 2,
  maxLength: 8,
}

const purchaseRateField: InvestmentFieldConfig = {
  name: "purchaseRate",
  label: "Kurs zakupu",
  type: "number",
  placeholder: "",
  required: false,
};

const sumField: InvestmentFieldConfig = {
  name: "primaryValue",
  label: "Kwota",
  type: "number",
  placeholder: "",
  required: true,
  step: "any",
  precision: 2,
  maxLength: 9,
}
const interestRateField: InvestmentFieldConfig =       {  
  name: "interestRate",
  label: "Wysokość oprocentowania",
  type: "number",
  placeholder: "",
  required: true,
  suffix: "%",
  step: "any",
  precision: 2,
  maxLength: 9,
};



const primaryValueField: InvestmentFieldConfig = {
  name: "primaryValue",
  label: "Wartość",
  type: "number",
  placeholder: "",
  required: true,
};

const priceField: InvestmentFieldConfig = {
  name: "primaryValue",
  label: "Cena zakupu",
  type: "number",
  placeholder: "",
  required: true,
  step: "any",
  precision: 2,
  maxLength: 9,
};

const quantityField: InvestmentFieldConfig = {
  name: "quantity",
  label: "Ilość",
  type: "number",
  placeholder: "",
  required: true,
};



const additionalInfoField: InvestmentFieldConfig = {
  name: "additionalInfo",
  label: "Dodatkowe informacje",
  type: "textarea",
  placeholder: "",
  required: false,
};

const relianceCanViewField: InvestmentFieldConfig = {
  name: "relianceCanView",
  label: "Udzielam zgody, by pracownicy firmy Reliance mieli dostęp do historii moich transakcji związanych z tym aktywem.",
  type: "checkbox",
  required: false,
};

// ─── Konfiguracje per typ aktywa ────────────────────────────────────────────

export const formConfigs: Record<string, InvestmentFormConfig> = {
  stocks: {
    slug: "stocks",
    fields: [
      nameField,
      quantityField,
      purchaseRateField,
      primaryValueField,
      currencyFieldRequired,
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
  },
  shares: {
    slug: "shares",
    fields: [
      nameField,
      quantityField,
      purchaseRateField,
      primaryValueField,
      currencyFieldRequired,
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
  },
  real_estate: {
    slug: "real_estate",
    fields: [
      {
        name: "propertyType",
        label: "",
        type: "radio",
        required: true,
        options: [
          { value: "apartment", label: "Mieszkanie" },
          { value: "house", label: "Dom" },
          { value: "land", label: "Działka" },
          { value: "other", label: "Inne" },
        ],
      },
      {
        name: "propertyTypeOther",
        label: "Nazwa",
        type: "text",
        placeholder: "",
        required: true,
        showWhen: { field: "propertyType", value: "other" },
      },
      priceField,
      currencyFieldRequired,
      {
        name: "area",
        label: "Powierzchnia [w m²]",
        type: "number",
        placeholder: "",
        required: false,
        step: "any",
        precision: 2,
        inputMode: "decimal",
        maxLength: 10,
      },
      {
        name: "_pricePerM2",
        label: "Cena za m²:",
        type: "computed",
        inline: true,
        computeFn: (values) => {
          const price = Number(values.primaryValue);
          const area = Number((values as any)["area"]);
          if (!price || !area || area === 0) return "—";
          return (price / area).toFixed(2);
        },
      },
      additionalInfoField,
      photoFilesField,
      contractFileField,
      relianceCanViewField,
    ],
  },
  crypto: {
    slug: "crypto",
    fields: [
      nameField,
      quantityCryptoField,
      {
        name: "primaryValue",
        label: "Kurs zakupu",
        type: "number",
        placeholder: "",
        required: false,
      },
      {
        name: "purchaseDate",
        label: "Data pierwszego zakupu tokenów / kryptowalut",
        type: "date",
        placeholder: "",
        required: true,
        yearMonthPicker: true,
      },
      currencyField,
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
  },
  precious_stones: {
    slug: "precious_stones",
    fields: [
      nameField,
      priceField,
      currencyFieldRequired,
      {
        name: "weight",
        label: "Masa",
        type: "number",
        placeholder: "",
        required: false,
        precision: 0,
        maxLength: 12,
        suffix: "g",
      },
      {
        name: "cut",
        label: "Szlif",
        type: "text",
        placeholder: "",
        required: false,
      },
      {
        name: "color",
        label: "Barwa",
        type: "text",
        placeholder: "",
        required: false,
      },
      {
        name: "clarity",
        label: "Czystość",
        type: "text",
        placeholder: "",
        required: false,
      },
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
  },
  precious_metals: {
    slug: "precious_metals",
    fields: [
      {
        name: "propertyType",
        label: "",
        type: "radio",
        required: true,
        options: [
          { value: "gold", label: "Złoto" },
          { value: "silver", label: "Srebro" },
          { value: "other", label: "Inne" },
        ],
      },
      {
        name: "name",
        label: "Nazwa",
        type: "text",
        placeholder: "",
        required: true,
        showWhen: { field: "propertyType", value: "other" },
      },
      priceField,
      currencyFieldRequired,
      {
        name: "weight",
        label: "Masa",
        type: "number",
        placeholder: "",
        required: false,
        precision: 0,
        maxLength: 12,
        suffix: "g",
      },
      {
        name: "finess",
        label: "Próba",
        type: "text",
        placeholder: "",
        required: false,
        maxLength: 6,
      },
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
  },
  treasury_bonds: {
    slug: "treasury_bonds",
    fields: [
      quantityCryptoField,
      currencyFieldRequired,
      sumField,
      {
        name: "acquisitionCost",
        label: "Cena nabycia:",
        type: "computed",
        placeholder: "",
        required: false,
        inline: true,
        computeSuffix: (values, currencyOptions) => {
          const selected = (currencyOptions ?? []).find((o: any) => o.value === values.currencyUuid);
          console.log(selected)
          const label: string = selected?.label ?? '';
          if (label === 'EUR') return '€';
          if (label === 'USD') return '$';
          return 'zł';
        },
        computeFn: (values) => {
          const kwota = parseFloat(String(values.primaryValue));
          const ilosc = parseFloat(String((values as any).quantity));
          if (!isNaN(kwota) && !isNaN(ilosc) && ilosc > 0) {
            return (kwota / ilosc).toFixed(2);
          }
          return "";
        },
      },
      interestRateField,
      {
        name: "interestType",
        label: "Rodzaj oprocentowania",
        type: "select",
        placeholder: "Wybierz",
        required: false,
        options: [
          { value: "fixed", label: "Stałe" },
          { value: "variable", label: "Zmienne" },
          { value: "periodically_fixed", label: "Okresowo-stałe" },
        ],
      },
      {
        name: "purchaseDate",
        label: "Data pierwszego zakupu obligacji skarbowych",
        type: "date",
        placeholder: "",
        required: true,
        yearMonthPicker: true,
      },
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
    transformValues: (values) => {
      const { interestRate, interestType, ...rest } = values;
      return {
        ...rest,
        details: {
          interestRate: interestRate !== "" && interestRate !== undefined ? Number(interestRate) : undefined,
          interestRateType: interestType || undefined,
        },
      };
    },
  },
  artwork: {
    slug: "artwork",
    fields: [
      {
        name: "artworkType",
        label: "Rodzaj",
        type: "text",
        placeholder: "",
        required: true,
      },
      priceField,
      currencyFieldRequired,
      {
        name: 'name',
        label: 'Tytuł',
        type: 'text',
        placeholder: '',
        required: false,
      },
      {
        name: 'author',
        label: 'Autor',
        type: 'text',
        placeholder: '',
        required: false,
      },
      {
        name: 'eraAge',
        label: 'Epoka/Wiek',
        type: 'text',
        placeholder: '',
        required: false,
      },
      additionalInfoField,
      photoFilesField,
      contractFileField,
      relianceCanViewField,
    ],
  },
  investment_policy: {
    slug: "investment_policy",
    fields: [
      nameField,
      currencyFieldRequired,
      {
        name: "contractDate",
        label: "Data zawarcia",
        type: "date",
        placeholder: "",
        required: false,
      },
      {
        name: "durationDate",
        label: "Czas trwania",
        type: "select",
        placeholder: "Wybierz",
        required: false,
        options: [
          { value: "indefinite", label: "Bezterminowo" },
          { value: "specific_date", label: "Dokładna data zakończenia" },
        ],
      },
       {
        name: "durationDateValue",
        label: "Data zakończenia",
        type: "date",
        placeholder: "",
        required: true,
        showWhen: { field: "durationDate", value: "specific_date" },
      },
      {
        name: "premiumPayment",
        label: "Składki",
        type: "select",
        placeholder: "Wybierz",
        required: false,
        options: [
          { value: "monthly", label: "Miesięczne" },
          { value: "quarterly", label: "Kwartalne" },
          { value: "yearly", label: "Roczne" },
          { value: "at_end_of_year", label: "Na koniec roku" },
        ],
      },
     
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
    transformValues: (values) => {
      const { durationDate, durationDateValue, ...rest } = values;
      if (durationDate === "indefinite") return { ...rest, durationDate: null };
      if (durationDate === "specific_date") return { ...rest, durationDate: durationDateValue ?? "" };
      return { ...rest, durationDate: "2000-01-01" };
    },
  },
  loans: {
    slug: "loans",
    fields: [
      {
        name: "loanType",
        label: "Forma pożyczki",
        type: "switch",
        required: true,
        options: [
          { value: "borrowed", label: "Zaciągnięta" },
          { value: "lent", label: "Udzielona" },
        ],
      },
      {
        name: "entity",
        label: "Podmiot",
        type: "text",
        placeholder: "",
        required: true,
      },
      sumField,
      currencyFieldRequired,
      interestRateField,
      {
        name: "interestRateType",
        label: "Rodzaj oprocentowania",
        type: "select",
        placeholder: "Wybierz",
        required: false,
        options: [
          { value: "fixed", label: "stałe" },
          { value: "variable", label: "zmienne" },
          { value: "periodically_fixed", label: "okresowo-stałe" },
        ],
      },
      {
        name: "interestPayment",
        label: "Odsetki",
        type: "select",
        placeholder: "Wybierz",
        required: false,
        options: [
          { value: "monthly", label: "Miesięczne" },
          { value: "quarterly", label: "Kwartalne" },
          { value: "yearly", label: "Roczne" },
          { value: "at_end_of_year", label: "Na koniec roku" },
        ],
      },
      {
        name: "contractDate",
        label: "Data zawarcia",
        type: "date",
        placeholder: "",
        required: false,
      },
      {
        name: "durationDate",
        label: "Czas trwania",
        type: "select",
        placeholder: "Wybierz",
        required: false,
        options: [
          { value: "indefinite", label: "Bezterminowo" },
          { value: "specific_date", label: "Dokładna data zakończenia" },
        ],
      },
      {
        name: "durationDateValue",
        label: "Data zakończenia",
        type: "date",
        placeholder: "",
        required: true,
        showWhen: { field: "durationDate", value: "specific_date" },
      },
      {
        name: "autoRenewal",
        label: "Automatyczne przedłużanie",
        type: "select",
        placeholder: "Wybierz",
        required: false,
        options: [
          { value: "true", label: "Tak" },
          { value: "false", label: "Nie" },
        ],
      },
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
    transformValues: (values) => {
      const { autoRenewal, durationDate, durationDateValue, ...rest } = values;
      const autoRenewalVal =
        autoRenewal === "true" ? true : autoRenewal === "false" ? false : null;
      const durationDateVal =
        durationDate === "indefinite"
          ? null
          : durationDate === "specific_date"
          ? (durationDateValue ?? "")
          : "2000-01-01";
      return { ...rest, autoRenewal: autoRenewalVal, durationDate: durationDateVal };
    },
  },
  currencies: {
    slug: "currencies",
    fields: [
      {...currencyField, label: 'Nazwa', required: true, excludeLabels: ['PLN']},
      {
        ...sumField,
        computeSuffix: (values, currencyOptions) => {
          const selected = (currencyOptions ?? []).find((o: any) => o.value === values.currencyUuid);
          const label: string = selected?.label ?? '';
          if (label === 'USD') return '$';
          if (label === 'EUR') return '€';
          if (label === 'GBP') return '£';
          if (label === 'CHF') return 'CHF';
          return '';
        },
      },
      {
        name: "purchaseRate",
        label: "Kurs zakupu",
        type: "number",
        placeholder: "",
        required: false,
        precision: 2,
        maxLength:10,
      },
      {
        name: "acquisitionCost",
        label: "Koszt nabycia:",
        type: "computed",
        placeholder: "",
        required: false,
        inline: true,
        suffix: "zł",
        computeFn: (values) => {
          const kwota = parseFloat(String(values.primaryValue));
          const kurs = parseFloat(String(values.purchaseRate));
          if (!isNaN(kwota) && !isNaN(kurs) && kwota > 0 && kurs > 0) {
            return (kwota * kurs).toFixed(2);
          }
          return "";
        },
      },
      {
        name: "purchaseDate",
        label: "Data pierwszego zakupu walut",
        type: "date",
        placeholder: "",
        required: true,
      },
      additionalInfoField,
      contractFileField,
      relianceCanViewField,
    ],
  },
  other_investments: {
    slug: "other_investments",
    fields: [
      nameField,
      primaryValueField,
      currencyFieldRequired,
      additionalInfoField,
      photoFilesField,
      {...contractFileField, label: "Pole do załączenia plików"},
      relianceCanViewField,
    ],
  },
};

export const getFormConfig = (slug: string): InvestmentFormConfig => {
  return formConfigs[slug] || formConfigs.other_investments;
};
